import { render, staticRenderFns } from "./todayRecord.vue?vue&type=template&id=bf03d7f2&scoped=true"
import script from "./todayRecord.vue?vue&type=script&lang=js"
export * from "./todayRecord.vue?vue&type=script&lang=js"
import style0 from "./todayRecord.vue?vue&type=style&index=0&id=bf03d7f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf03d7f2",
  null
  
)

export default component.exports